var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("CameraTestBase", {
        on: { stream: _vm.onStream, previewVideo: _vm.onPreviewVideo },
      }),
      _c("canvas", {
        ref: "landmarkCvs",
        staticStyle: {
          position: "absolute",
          left: "0px",
          top: "0px",
          "pointer-events": "none",
        },
      }),
      _c("div", [
        _c("div", [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.grmWebgl.type,
                  expression: "grmWebgl.type",
                },
              ],
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.grmWebgl,
                    "type",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            _vm._l(_vm.grmWebgl.types, function (type) {
              return _c("option", { key: type, domProps: { value: type } }, [
                _vm._v(_vm._s(type)),
              ])
            }),
            0
          ),
          _c("button", { on: { click: _vm.grmMediaStreamTrackGenerator } }, [
            _vm._v(_vm._s(_vm.grmWebgl.created ? "reload" : "create")),
          ]),
          _vm.grmWebgl.created
            ? _c("label", { staticClass: "info" }, [
                _c("span", [_vm._v("created")]),
                _c("span", [_vm._v(_vm._s(_vm.grmWebgl.created) + "ms")]),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.grmWebgl.created,
                expression: "grmWebgl.created",
              },
            ],
          },
          [
            _c("div", { staticClass: "layer" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.grmWebgl.mirror,
                      expression: "grmWebgl.mirror",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.grmWebgl.mirror)
                      ? _vm._i(_vm.grmWebgl.mirror, null) > -1
                      : _vm.grmWebgl.mirror,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.grmWebgl.mirror,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.grmWebgl, "mirror", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.grmWebgl,
                              "mirror",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.grmWebgl, "mirror", $$c)
                      }
                    },
                  },
                }),
                _c("span", [_vm._v("mirror")]),
              ]),
              _vm._v(" blur: " + _vm._s(_vm.grmWebgl.blur)),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.grmWebgl.blur,
                    expression: "grmWebgl.blur",
                  },
                ],
                attrs: { type: "range", min: "0", max: "30" },
                domProps: { value: _vm.grmWebgl.blur },
                on: {
                  __r: function ($event) {
                    return _vm.$set(_vm.grmWebgl, "blur", $event.target.value)
                  },
                },
              }),
              _vm._v(" fps: " + _vm._s(_vm.grmWebgl.fps)),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.grmWebgl.fps,
                    expression: "grmWebgl.fps",
                  },
                ],
                attrs: { type: "range", min: "1", max: "60" },
                domProps: { value: _vm.grmWebgl.fps },
                on: {
                  __r: function ($event) {
                    return _vm.$set(_vm.grmWebgl, "fps", $event.target.value)
                  },
                },
              }),
              _c("button", { on: { click: _vm.playCaptureStream } }, [
                _vm._v("playCaptureStream"),
              ]),
            ]),
            _c("div", [
              _vm._v(
                " top-down blurPercent: " +
                  _vm._s(_vm.grmWebgl.topDownBlur.percent)
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.grmWebgl.topDownBlur.percent,
                    expression: "grmWebgl.topDownBlur.percent",
                  },
                ],
                attrs: { type: "range", min: "0", max: "1", step: "0.1" },
                domProps: { value: _vm.grmWebgl.topDownBlur.percent },
                on: {
                  __r: function ($event) {
                    return _vm.$set(
                      _vm.grmWebgl.topDownBlur,
                      "percent",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" blurSize: " + _vm._s(_vm.grmWebgl.topDownBlur.blurSize)),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.grmWebgl.topDownBlur.blurSize,
                    expression: "grmWebgl.topDownBlur.blurSize",
                  },
                ],
                attrs: { type: "range", min: "0", max: "100" },
                domProps: { value: _vm.grmWebgl.topDownBlur.blurSize },
                on: {
                  __r: function ($event) {
                    return _vm.$set(
                      _vm.grmWebgl.topDownBlur,
                      "blurSize",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
            _c("div", [
              _c("div", [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.grmWebgl.faceDrawType,
                        expression: "grmWebgl.faceDrawType",
                      },
                    ],
                    attrs: { type: "radio", value: "" },
                    domProps: {
                      checked: _vm._q(_vm.grmWebgl.faceDrawType, ""),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.grmWebgl, "faceDrawType", "")
                      },
                    },
                  }),
                  _c("span", [_vm._v("None")]),
                ]),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.grmWebgl.faceDrawType,
                        expression: "grmWebgl.faceDrawType",
                      },
                    ],
                    attrs: { type: "radio", value: "box" },
                    domProps: {
                      checked: _vm._q(_vm.grmWebgl.faceDrawType, "box"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.grmWebgl, "faceDrawType", "box")
                      },
                    },
                  }),
                  _c("span", [_vm._v("Box")]),
                ]),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.grmWebgl.faceDrawType,
                        expression: "grmWebgl.faceDrawType",
                      },
                    ],
                    attrs: { type: "radio", value: "faceImage" },
                    domProps: {
                      checked: _vm._q(_vm.grmWebgl.faceDrawType, "faceImage"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.grmWebgl,
                          "faceDrawType",
                          "faceImage"
                        )
                      },
                    },
                  }),
                  _c("span", [_vm._v("Emoji")]),
                ]),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.grmWebgl.faceDrawType,
                        expression: "grmWebgl.faceDrawType",
                      },
                    ],
                    attrs: { type: "radio", value: "mosaic" },
                    domProps: {
                      checked: _vm._q(_vm.grmWebgl.faceDrawType, "mosaic"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.grmWebgl, "faceDrawType", "mosaic")
                      },
                    },
                  }),
                  _c("span", [_vm._v("Mosaic")]),
                ]),
              ]),
              _c(
                "div",
                { staticStyle: { "pointer-events": "none" } },
                _vm._l(_vm.grmWebgl.emojiList, function (emoji) {
                  return _c("img", {
                    key: emoji,
                    staticClass: "emoji",
                    staticStyle: { "pointer-events": "auto" },
                    attrs: { width: "50", height: "50", src: emoji },
                    on: {
                      click: function ($event) {
                        return _vm.drawEmogiToFace(emoji)
                      },
                    },
                  })
                }),
                0
              ),
            ]),
            _c("div", { ref: "pixiLayer", staticClass: "layer" }, [
              _c("canvas", {
                ref: "canvas",
                attrs: { width: "1", height: "1" },
              }),
            ]),
            _vm.grmWebgl.playCaptureStream
              ? _c("div", { staticClass: "layer" }, [
                  _c("div", [
                    _vm._v(" fps: " + _vm._s(_vm.grmWebgl.csFps)),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.grmWebgl.csFps,
                          expression: "grmWebgl.csFps",
                        },
                      ],
                      attrs: { type: "range", min: "1", max: "60" },
                      domProps: { value: _vm.grmWebgl.csFps },
                      on: {
                        __r: function ($event) {
                          return _vm.$set(
                            _vm.grmWebgl,
                            "csFps",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", [
                    _c("video", {
                      ref: "captureVideo",
                      attrs: {
                        autoplay: "",
                        playsinline: "",
                        crossorigin: "anonymous",
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }